import { z } from 'zod'
import { honeybookFunnelMapSchema } from '../dto/honeybook.dto.js'
import { calendarDaySchema } from '../validators/calendar-day.validator.js'

/** What HoneyBook's sign-in hands back to the web app, passed on to the API to finish connecting. */
export const finishHoneybookSignInInputSchema = z
  .object({
    code: z.string().min(1).max(2048),
    state: z.string().min(1).max(512),
  })
  .strict()

export type FinishHoneybookSignInInput = z.infer<typeof finishHoneybookSignInInputSchema>

/** What a venue's HoneyBook stages and meetings mean, saved whole; and the track its events start on. */
export const updateHoneybookConnectionInputSchema = z
  .object({
    funnelMap: honeybookFunnelMapSchema.optional(),
    eventTrackId: z.string().uuid().nullable().optional(),
  })
  .strict()

export type UpdateHoneybookConnectionInput = z.infer<typeof updateHoneybookConnectionInputSchema>

/** Which page of events waiting for review. */
export const honeybookReviewQuerySchema = z.object({ page: z.coerce.number().int().min(1).max(1000).optional() }).strict()

export type HoneybookReviewQuery = z.infer<typeof honeybookReviewQuerySchema>

/** "This is it": the booking an event waiting for review is. */
export const confirmHoneybookReviewInputSchema = z.object({ projectId: z.string().min(1).max(64) }).strict()

export type ConfirmHoneybookReviewInput = z.infer<typeof confirmHoneybookReviewInputSchema>

/** Switch a venue from HoneyBook to FLOH Venues on a day, today or later at the venue (docs/honeybook.plan.md, 7.2). */
export const startHoneybookSwitchInputSchema = z.object({ cutoverDate: calendarDaySchema }).strict()

export type StartHoneybookSwitchInput = z.infer<typeof startHoneybookSwitchInputSchema>
